// removed by extract-text-webpack-plugin
module.exports = {"block":"search-results-PremiumIcon-block","tipContent":"search-results-PremiumIcon-tipContent"};


//////////////////
// WEBPACK FOOTER
// ./src/components/search/results/PremiumIcon/index.css
// module id = 1845
// module chunks = 0